import Image from "next/image"
import styles from "./tnpsc-group-II-mains-test-series.module.css";
// import group2amaintest from "../../assets/images/Tnpsc/TNPSC-GrIIA-Mains-WebBanner.jpg";
// import Mobbanner from "../../assets/images/Tnpsc/TNPSC-GrIIA-Mains-MobBanner.jpg";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import dynamic from "next/dynamic";
const Interest = dynamic(()=>import("../../components/might-be-interest"));
import Head from "next/head";
import Link from "next/link";
const Tnpsc_Group2_2A_Mains_2022_New_Test_Series_Paper2 = () => {

    const feestructure3 =[

    {center: "AnnaNagar", mode: "Batch I - (Offline & Online) ", start: "20-11-2026",
            fee: (<><div>₹20,000 (For  SIA  Students)</div> <div>₹22,000 (For New Students )</div><div>₹22,000 (For Online All Students )</div> </>),
          cont3: (<><div><Link href="https://www.shankariasacademy.com/pdf/TNPSC-2026/Tnpsc-GRP-IIA-Mains-TestSeries-2026/AnnaNagar/Tnpsc-GRP-IIA-Mains-B1-2026.pdf" target="_blank" className={`${styles.paybill}`}>Download PDF</Link></div> </>),
            pay: (<a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=TNPSC" target="_blank" rel="noopener noreferrer">
                    <button className={`${styles.normalbutton1} btn btn-danger`}>
                      Pay Now
                    </button>
                </a>)
        },

    {center: "Namakkal", mode: "Batch I - Offline", start: "26-11-2026",
            fee: (<><div>₹20,000 (For  SIA  Students)</div> <div>₹22,000 (For New Students )</div> </>),
          cont3: (<><div><Link href="https://www.shankariasacademy.com/pdf/TNPSC-2026/Tnpsc-GRP-IIA-Mains-TestSeries-2026/Namakkal/Tnpsc-GRP-IIA-Mains-B1-2026.pdf" target="_blank" className={`${styles.paybill}`}>Download PDF</Link></div> </>),
            pay: (<a href="https://admissionsv1.shankariasacademy.com/?center=Namakkal&coursetype=TNPSC" target="_blank" rel="noopener noreferrer">
                    <button className={`${styles.normalbutton1} btn btn-danger`}>
                      Pay Now
                    </button>
                </a>)
        },

    ]
   
    return (
        <>
        <Head>
            <meta charset="UTF-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="robots" content="noodp,noydir" />
            <meta name="robots" content="index,follow" />
            <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
            <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
            <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
            <title>TNPSC Group IIA Mains Test Series 2026 | Shankar IAS Academy</title>
            <meta name="title" content="TNPSC Group IIA Mains Test Series 2026 | Shankar IAS Academy" />
            <meta name="description" content="Prepare for success with our TNPSC Group IIA Mains Test Series 2026. Get expert-designed mock tests and detailed solutions for effective exam preparation." />
            <link rel="canonical" href="https://www.shankariasacademy.com/tnpsc-group-IIA-mains-test-series/" />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content="TNPSC Group IIA Mains Test Series 2026 | Shankar IAS Academy" />
            <meta property="og:description" content="TNPSC Group Ⅱ Main Test Paper Ⅱ | TNPSC Test Series, Online and Offline for Regular and Weekend Batch Students is the Best in Tamil Nadu for Group Ⅱ Mains" />
            <meta property="og:url" content="https://www.shankariasacademy.com/tnpsc-group-IIA-mains-test-series/" />
            <meta property="og:site_name" content="Shankar IAS Academy" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@shankarias" />
        </Head>

    <Navbar title="tnpsc" />

    <div className="container">

            <div className="row">
                <div className="col pt-3 pt-md-4">
                    <h1 className={`${styles.pagemaintitle}`}>I'M TOP TNPSC Group IIA Mains Test Series 2026</h1>
                </div>
            </div>

            {/* <div className="row d-none d-md-block">
                <div className="col pt-2 mb-3">
                    <Image src={group2amaintest} alt="tnpsc-group-II-mains-test-series banner" title="TNPSC Group II/II-A Mains 2024 New Test Series" className="img-fluid w-100" />
                </div>
            </div>

            <div className="row  d-block d-md-none">
                <div className="col pt-2 mb-3">
                    <Image src={Mobbanner} alt="tnpsc-group-II-mains-test-series banner" title="TNPSC Group II/II-A Mains 2024 New Test Series" className="img-fluid w-100" />
                </div>
            </div>  */}

          {/* <div className="row pt-2">
                <div className="col-md-9 col-12">
                    <h2 className={`${styles.sectiontitle} mb-0`}>TNPSC Group IIA Mains 2024 New Test Series Paper II</h2>
                </div>

                 <div className="col">
                <Link href="/tnpsc-mains-test-series" ><button className={`${styles.normalbutton1} mt-2 mt-md-0`} type="submit">TNPSC Group II/II-A Mains Paper I </button></Link>
                </div>
            </div> */}

    </div>


   <section  id="courseandfees">
        <div className="container pt-xl-4" >
                <div className="row">
                   <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#7f0801" }}>Center</div>
                   <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#7f0801" }}>Mode</div>
                   <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#7f0801" }}>Starts on</div>
                   <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#7f0801" }}>Fee</div>
                   <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#7f0801" }}>Schedule</div>
                   <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#7f0801" }}>Payment</div>
                   <hr/>
                </div>
                        
                {feestructure3.map((item,index)=>(
                    <div className={`${styles.facultyborder3} row`}>
                        <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Center</div>
                            <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-0`}>{item.center}</div>
                        <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Mode</div>
                            <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-0  pb-md-3`}>{item.mode}</div>
                        <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Starts on</div>
                            <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-0`}>{item.start}</div>
                        <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Fee</div>
                            <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-0`}>{item.fee}</div>
                        <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Schedule</div>
                            <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-0`}>{item.cont3}</div>
                        <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Payment</div>
                        <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-2 text-center pt-2 pt-md-0`}>
                                {item.pay}
                        </div>
                        <hr/>
                    </div>
                ))} 
        </div>
    </section> 


    <Interest />
    <Footer />

        </>
    )
}

export default Tnpsc_Group2_2A_Mains_2022_New_Test_Series_Paper2
